import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

const S_LandingPage = () => {
    const [address, setAddress] = useState('');


    return (
        <>

        </>
    );
};

export default S_LandingPage;
